export const JOURNEY_ENVELOPE_ERROR_CODES = {
  InvalidEnvelope: "INVALID_ENVELOPE",
  NodeConfigTypeMismatch: "NODE_CONFIG_TYPE_MISMATCH",
  EdgeEndpointMissing: "EDGE_ENDPOINT_MISSING",
  EdgeSelfReference: "EDGE_SELF_REFERENCE",
  DuplicateEdge: "DUPLICATE_EDGE",
  DuplicateNodeId: "DUPLICATE_NODE_ID",
  Cycle: "CYCLE",
  EntryNodeCount: "ENTRY_NODE_COUNT",
  InvalidFanOut: "INVALID_FAN_OUT",
  BranchFamilyMismatch: "BRANCH_FAMILY_MISMATCH",
  BranchParentCardinality: "BRANCH_PARENT_CARDINALITY",
  SegmentCatchAllOrder: "SEGMENT_CATCH_ALL_ORDER",
  DuplicateSegmentPriority: "DUPLICATE_SEGMENT_PRIORITY",
  SplitPercentageTotal: "SPLIT_PERCENTAGE_TOTAL",
  WaitBranchCardinality: "WAIT_BRANCH_CARDINALITY",
  TimeDelayVariantCount: "TIME_DELAY_VARIANT_COUNT",
  WaitConditionVariantCount: "WAIT_CONDITION_VARIANT_COUNT",
  EntryLimitConstraint: "ENTRY_LIMIT_CONSTRAINT",
  MessageChannelMismatch: "MESSAGE_CHANNEL_MISMATCH",
  EmptyExitCriteriaGroup: "EMPTY_EXIT_CRITERIA_GROUP",
  DuplicateContextVariable: "DUPLICATE_CONTEXT_VARIABLE",
  ContextNotEnabled: "CONTEXT_NOT_ENABLED",
  MissingContextVariable: "MISSING_CONTEXT_VARIABLE",
  ContextVariableTypeMismatch: "CONTEXT_VARIABLE_TYPE_MISMATCH",
  InvalidSidecarPlacement: "INVALID_SIDECAR_PLACEMENT",
  DuplicateSyncReference: "DUPLICATE_SYNC_REFERENCE",
  MissingNodeReference: "MISSING_NODE_REFERENCE",
  SyncExitModeMismatch: "SYNC_EXIT_MODE_MISMATCH",
  CouponAssignmentEventEntry: "COUPON_ASSIGNMENT_EVENT_ENTRY",
  MissingCouponContextVariable: "MISSING_COUPON_CONTEXT_VARIABLE",
  DuplicateCouponContextVariable: "DUPLICATE_COUPON_CONTEXT_VARIABLE",
  CouponContextVariableOwnership: "COUPON_CONTEXT_VARIABLE_OWNERSHIP",
  SegmentsBranchCardinality: "SEGMENTS_BRANCH_CARDINALITY",
  DecisionArmCardinality: "DECISION_ARM_CARDINALITY",
  DuplicateNoteId: "DUPLICATE_NOTE_ID",
  NoteTargetXor: "NOTE_TARGET_XOR",
  NoteNodeMissing: "NOTE_NODE_MISSING",
  InvalidAuthoringStatus: "INVALID_AUTHORING_STATUS",
  UnsupportedNodeType: "UNSUPPORTED_NODE_TYPE",
  NodeTypeNotRealtime: "NODE_TYPE_NOT_REALTIME",
  RealtimeHoldWithoutEventBranch: "REALTIME_HOLD_WITHOUT_EVENT_BRANCH",
  RealtimeConditionUnsupported: "REALTIME_CONDITION_UNSUPPORTED",
  RealtimeJourneysNotEnabled: "REALTIME_JOURNEYS_NOT_ENABLED",
  RealtimeSyncMappingUnsupported: "REALTIME_SYNC_MAPPING_UNSUPPORTED",
  RealtimeSyncDestinationNotFound: "REALTIME_SYNC_DESTINATION_NOT_FOUND",
  RealtimeFunctionNotFound: "REALTIME_FUNCTION_NOT_FOUND",
  RealtimeFunctionEventModelNotFound: "REALTIME_FUNCTION_EVENT_MODEL_NOT_FOUND",
  RealtimeFunctionEventModelFilterUnsupported:
    "REALTIME_FUNCTION_EVENT_MODEL_FILTER_UNSUPPORTED",
  RealtimeFunctionEventModelMissingFields:
    "REALTIME_FUNCTION_EVENT_MODEL_MISSING_FIELDS",
  RealtimeFunctionBranchShape: "REALTIME_FUNCTION_BRANCH_SHAPE",
  RealtimeFunctionBranchEventModel: "REALTIME_FUNCTION_BRANCH_EVENT_MODEL",
  RealtimeMessagesNotEnabled: "REALTIME_MESSAGES_NOT_ENABLED",
  RealtimeMessageChannelUnsupported: "REALTIME_MESSAGE_CHANNEL_UNSUPPORTED",
  RealtimeMessageDynamicContent: "REALTIME_MESSAGE_DYNAMIC_CONTENT",
  RealtimeMessageCepNotConfigured: "REALTIME_MESSAGE_CEP_NOT_CONFIGURED",
  RealtimeMessageRequiredSubsets: "REALTIME_MESSAGE_REQUIRED_SUBSETS",
  RealtimeMessageDeliveryHandleNotMapped:
    "REALTIME_MESSAGE_DELIVERY_HANDLE_NOT_MAPPED",
  RealtimeMessageDeliveryHandleMissing:
    "REALTIME_MESSAGE_DELIVERY_HANDLE_MISSING",
  RealtimeMessageVariableUnsupported: "REALTIME_MESSAGE_VARIABLE_UNSUPPORTED",
  RealtimeEmissionEventModelNotFound: "REALTIME_EMISSION_EVENT_MODEL_NOT_FOUND",
  RealtimeEmissionEventModelUnsupported:
    "REALTIME_EMISSION_EVENT_MODEL_UNSUPPORTED",
  RealtimeEmissionPayloadTooLarge: "REALTIME_EMISSION_PAYLOAD_TOO_LARGE",
  UnsupportedSchedule: "UNSUPPORTED_SCHEDULE",
  MalformedNodeConfig: "MALFORMED_NODE_CONFIG",
  MalformedSidecar: "MALFORMED_SIDECAR",
  JourneyNotFound: "JOURNEY_NOT_FOUND",
  JourneyVersionNotEditable: "JOURNEY_VERSION_NOT_EDITABLE",
  JourneyDeleted: "JOURNEY_DELETED",
  JourneyArchived: "JOURNEY_ARCHIVED",
  JourneyResetting: "JOURNEY_RESETTING",
  JourneyHasRunningSyncs: "JOURNEY_HAS_RUNNING_SYNCS",
  InvalidJourneyMetadata: "INVALID_JOURNEY_METADATA",
  ParentModelMismatch: "PARENT_MODEL_MISMATCH",
  InvalidJourneyLifecycleChange: "INVALID_JOURNEY_LIFECYCLE_CHANGE",
  InvalidExitCriteria: "INVALID_EXIT_CRITERIA",
  InvalidContextConfig: "INVALID_CONTEXT_CONFIG",
  InvalidContextVariableName: "INVALID_CONTEXT_VARIABLE_NAME",
  ContextVariableTypeLocked: "CONTEXT_VARIABLE_TYPE_LOCKED",
  MissingGraphNodesOrEdges: "MISSING_GRAPH_NODES_OR_EDGES",
  EmptyGraph: "EMPTY_GRAPH",
  InvalidNode: "INVALID_NODE",
  InvalidSyncConfig: "INVALID_SYNC_CONFIG",
  NodeTypeChange: "NODE_TYPE_CHANGE",
  InvalidEdge: "INVALID_EDGE",
  CouponPoolNotFound: "COUPON_POOL_NOT_FOUND",
  CouponPoolTypeMismatch: "COUPON_POOL_TYPE_MISMATCH",
  CouponPoolColumnMissing: "COUPON_POOL_COLUMN_MISSING",
  CouponPoolColumnTypeMismatch: "COUPON_POOL_COLUMN_TYPE_MISMATCH",
  CouponVariableLocked: "COUPON_VARIABLE_LOCKED",
  AudienceExperimentNotEnabled: "AUDIENCE_EXPERIMENT_NOT_ENABLED",
  MessageIncomplete: "MESSAGE_INCOMPLETE",
  RtaAudienceNotReady: "RTA_AUDIENCE_NOT_READY",
  AudienceExperimentNotReady: "AUDIENCE_EXPERIMENT_NOT_READY",
  HttpLookupNotEnabled: "HTTP_LOOKUP_NOT_ENABLED",
  InvalidHttpLookupConfig: "INVALID_HTTP_LOOKUP_CONFIG",
} as const;

export type JourneyEnvelopeErrorCode =
  (typeof JOURNEY_ENVELOPE_ERROR_CODES)[keyof typeof JOURNEY_ENVELOPE_ERROR_CODES];

export type JourneyEnvelopeDiagnosticBucket =
  | "unsupportedFeatures"
  | "violations";

export type JourneyEnvelopeIssueParams = {
  code: JourneyEnvelopeErrorCode;
  bucket: JourneyEnvelopeDiagnosticBucket;
};
